import { useQuery } from '@tanstack/react-query';
import { paymentApis } from '../api/paymentApi';

export const useStripeConnectStatus = () => {
  return useQuery({
    queryKey: ['stripe-connect-status'],
    queryFn: () => paymentApis.getStripeConnectStatus(),
  });
};
